
import { getProType, formatBestOffer, formatOffer, formatAmount, formatRedeemInside } from "./format"
import bestOffer from "./best-offer"
import freebieOffer from "./freebie-offer"
import freebieAmount from "./freebie-amount"
import redeemInside from "./redeem-inside"
import outsideOffer from "./outside-offer"
import outsideAmount from "./outside-amount"
import { showGlobalMessage } from "@/utils/utils"

export default {
  components: {
    bestOffer,
    freebieOffer,
    freebieAmount,
    redeemInside,
    outsideOffer,
    outsideAmount
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      type: "",
      coreData: {}
    }
  },
  computed: {},
  watch: {
    info: {
      handler(newVal) {
        if (newVal.alertContent) {
          showGlobalMessage({
            message: newVal.alertContent,
            gap: 150,
            iconClass: "messageWarning"
          })
        }
        if (newVal) {
          this.formatCoreData(newVal)
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    formatCoreData(data) {
      this.type = getProType(data)
      switch (this.type) {
        case "best-offer":
          this.coreData = formatBestOffer(data)
          break
        case "freebie-offer":
          this.coreData = formatOffer(data)
          break
        case "freebie-amount":
          this.coreData = formatAmount(data)
          break
        case "outside-offer":
          // 换购产品弹窗
          this.coreData = formatOffer(data)
          break
        case "outside-amount":
          this.coreData = formatAmount(data)
          break
        // case 'redeem-inside':
        //   this.coreData = formatRedeemInside(data);
        //   break;
        default:
          break
      }
    }
  }
}
